import { render, staticRenderFns } from "./GridCells.vue?vue&type=template&id=28f6eec6&lang=pug"
import script from "./GridCells.vue?vue&type=script&lang=js"
export * from "./GridCells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports